<template>
  <div v-if="list" class="shopOptionList">
    <ul class="optionList clickable">
      <li
        v-for="(optionItem, index) in filteredListAll"
        :key="index"
        class="optionItem"
        :class="{isBaseShopPos: optionItem.isBaseShopPos, disabled: (disabledItemIds && disabledItemIds.includes(optionItem.id))}"
        @click="clicked(optionItem)">
        {{ optionItem.title }}
      </li>
      <li v-if="filteredListAll.length <= 0" class="optionItem">선택 가능한 옵션이 없습니다.</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'OptionListAll',
  props: [
    'locale',
    'id',
    'filterIds',
    'searchWord',
    'disabledItemIds',
    'disabled',
    'mustPosSync',
    'shopItemId'
  ],
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    filteredListAll () {
      const filterIds = this.filterIds || []
      const list = this.list.filter(item => !filterIds.includes(item.id)) || []

      const word = regExp.replaceAllEmpty(this.searchWord || '')

      function filterListByWord(list, w) {
        if (!w) return list

        return list.filter(item => {
          // 1) option.title
          if (regExp.replaceAllEmpty(item.title).includes(w)) {
            return true
          }

          // 2) option.title
          if (regExp.replaceAllEmpty(item.id).includes(w)) {
            return true
          }

          // 3) title의 모든 언어 값
          if (hasObjectValueMatch(item.name, w)) {
            return true
          }

          return false
        });
      }

      function hasObjectValueMatch(obj, word) {
        if (!obj || typeof obj !== 'object') return false

        return Object.values(obj).some(v =>
          regExp.replaceAllEmpty(v).includes(word)
        );
      }
      return filterListByWord(list, word)
    }
  },
  async created () {
    await this.getOptionListAll()
    this.$emit('update', this.list)
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    async getOptionListAll () {
      this.$store.commit('onLoading', true)
      const getList = await this.$store.dispatch('shop/getShopStoreOptionList', this.shopItemId)
      const list = getList && getList.message && getList.message.option
      if (list) {
        this.list = list.map(item => {
          return {
            ...item,
            title: item.title || item.name[this.defaultLang]
          }
        })
      }
      this.$store.commit('onLoading', false)
    },
    clicked (optionItem) {
      if (!this.disabled || !this.disabledItemIds.includes(optionItem.id)) {
        this.$emit('clicked', optionItem)
      }
    }
  }
}
</script>